import {z} from 'zod';

export const dlqCountsErrorResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
  timestamp: z.string(),
});
